import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

export const AgentAgencyFormDefaultValues = {
  brandedAs: "",
  clientlinqBranch: "",
  streetAddress: "",
  city: "",
  province: "",
  postalCode: "",
  businessPhone: "",
  ttandEmail: "",
  firstname: "",
  lastname: "",
  agentId: "",
  status: false,
  agentType: "",
};

export const agentAgencyFormTabs = {
  createAgent: {
    id: "createAgent",
    title: "Create Agent",
    mode: "create",
    type: "agent",
    Icon: PersonAddAltOutlinedIcon,
  },
  createAgency: {
    id: "createAgency",
    title: "Create Agency",
    mode: "create",
    type: "agency",
    Icon: GroupAddOutlinedIcon,
  },
  updateAgent: {
    id: "updateAgent",
    title: "Update Agent",
    mode: "update",
    type: "agent",
    Icon: ManageAccountsIcon,
  },
  updateAgency: {
    id: "updateAgency",
    title: "Update Agency",
    mode: "update",
    type: "agency",
    Icon: GroupOutlinedIcon,
  },
} as const;
